import { useFormikContext } from "formik";

const CustomPhoneField = ({
  field,
  id,
  className,
  placeholder,
  maxLength = 12,
}) => {
  const { setFieldValue } = useFormikContext();

  const handleChange = (e) => {
    const onlyNums = e.target.value.replace(/\D/g, "");
    setFieldValue(field.name, onlyNums);
  };

  return (
    <input
      {...field}
      id={id}
      type="text"
      className={className}
      placeholder={placeholder}
      onChange={handleChange}
      value={field.value}
      maxLength={maxLength}
      inputMode="numeric"
    />
  );
};

export default CustomPhoneField;
